import { backdropClasses } from '@mui/material/Backdrop';
import { dialogClasses } from '@mui/material/Dialog';

const sharedDialogStyles = (theme) => ({
  [`& .${backdropClasses.root}`]: {
    backgroundColor: theme.palette.scrim
  },
  [`& .${dialogClasses.paper}`]: {
    backgroundColor: theme.palette.surface.content,
    backgroundImage: 'none',
    border: `1px solid ${theme.palette.hairline.main}`,
    borderRadius: '14px',
    boxShadow: theme.palette.shadow.menu,
    [theme.breakpoints.up('md')]: {
      borderRadius: '16px'
    }
  }
});

export default sharedDialogStyles;
